module.exports = __webpack_public_path__ + "img/bg.9661d66d.jpg";